// extracted by mini-css-extract-plugin
export default {"search":"style_search__axj8w","plus":"style_plus__SayZO","searchicon":"style_searchicon__7eD08"};